function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5,
  transform: "translate(3 3)"
}, React.createElement("path", {
  d: "M100 50c0 38.889-50 72.222-50 72.222S0 88.89 0 50C0 22.386 22.386 0 50 0s50 22.386 50 50z"
}), React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 16.667
}));

var SvgMapPin = function SvgMapPin(props) {
  return React.createElement("svg", _extends({
    width: 106,
    height: 128,
    viewBox: "0 0 106 128"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/map-pin.589c45e5.svg";
export { SvgMapPin as ReactComponent };